/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/24/22
 */

import React from "react";
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";

export interface BooleanControlProps {
	label?: string
	value?: boolean
	onChange: (value: boolean|null) => void
	hideNoFilter?: boolean
	disabled?: boolean
}

export default function BooleanControl(props: BooleanControlProps) {

	return (
		<FormControl variant={"standard"} sx={{ minWidth: 100 }}>
			{props.label && <InputLabel>{props.label}</InputLabel>}
			<Select
				value={props.value !== undefined ? (props.value ? "yes" : "no") : ""}
				disabled={props.disabled}
				onChange={(event) => {
					const value = event.target.value as string;
					props.onChange(value === "yes" ? true : (value === "no" ? false : null))
				}}
			>
				{!props.hideNoFilter && <MenuItem value={""}>No filter</MenuItem>}
				<MenuItem value={"yes"}>Yes</MenuItem>
				<MenuItem value={"no"}>No</MenuItem>
			</Select>
		</FormControl>
	);

}